import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { LayoutGrid, PackageX, ListChecks, PackageSearch, Truck, Settings2 } from 'lucide-react';
import { useAuth } from '../AuthContext';
import './DashboardMenuHeader.css';

const DashboardMenuHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { hasAccess } = useAuth();
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  const menuItems = [
    { path: '/panelalmacen', label: 'Panel Almacén', icon: Settings2 },
    { path: '/almacennotasentrega', label: 'Notas de Entrega', icon: ListChecks },
    { path: '/consolidaciondespacho', label: 'Consolidación', icon: Truck },
    { path: '/notascalmacen', label: 'NC Devoluciones', icon: PackageX },
    { path: '/inventarioalmacen', label: 'Inventario', icon: PackageSearch },
  ];
  const visibleMenuItems = menuItems.filter(item => hasAccess(item.path));

  return (
    <motion.div 
      className="dashboard-menu-header"
      initial={isMobile ? { y: 0, opacity: 1 } : { y: -20, opacity: 0 }}
      animate={isMobile ? { y: 0, opacity: 1 } : { y: 0, opacity: 1 }}
      transition={isMobile ? { duration: 0 } : { duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
    >
      <div className="header-left">
        {hasAccess('/almacen') && (
          <button className="nav-icon-btn back-btn" onClick={() => navigate('/almacen')} title="Volver al Menú">
            <LayoutGrid size={20} />
          </button>
        )}
        <div className="vertical-divider"></div>
      </div>
      
      <div className="header-nav-items">
        {visibleMenuItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <button 
              key={item.path}
              className={`nav-tab-item ${isActive ? 'active' : ''}`}
              onClick={() => navigate(item.path)}
            >
              <item.icon size={16} className="tab-icon" />
              <span className="tab-label">{item.label}</span>
              {isActive && (
                <motion.div 
                  className="active-tab-indicator" 
                  layoutId="activeTabIndicator"
                  transition={{ type: "spring", stiffness: 500, damping: 30 }}
                />
              )}
            </button>
          );
        })}
      </div>
    </motion.div>
  );
};

export default DashboardMenuHeader;